import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

export default function MobileTabs({ tabs = [], activeId, onTabClick }) {
	const primary = ['chat', 'summary'];
	const secondary = tabs.filter(t => !primary.includes(t.id)).map(t => t.id);

	const [showMore, setShowMore] = useState(false);
	const ref = useRef(null);

	useEffect(() => {
		function handleClickOutside(e) {
			if (ref.current && !ref.current.contains(e.target)) setShowMore(false);
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	const find = (id) => tabs.find(t => t.id === id);

	return (
		<div className="flex items-center justify-between space-x-2 px-2 py-1 bg-gray-100 dark:bg-gray-800 rounded-xl overflow-x-auto scrollbar-hide">
			{primary.map(id => {
				const tab = find(id);
				if (!tab) return null;
				return (
					<button
						key={id}
						onClick={() => onTabClick?.(id)}
						className={`flex items-center space-x-2 px-2 py-2 rounded-lg text-sm font-semibold transition ${
							activeId === id ? 'bg-black text-white' : 'text-black dark:bg-gray-900 dark:text-white'
						}`}
					>
						<span>{tab.icon}</span>
						<span>{tab.label}</span>
					</button>
				);
			})}
			<div className="relative" ref={ref}>
				<button
					onClick={() => setShowMore(s => !s)}
					className="flex-shrink-0 flex items-center space-x-2 px-3 py-2 text-sm font-semibold transition"
				>
					<span>More</span>
					<ChevronDown size={16} className={`transition-transform ${showMore ? 'rotate-180' : ''}`} />
				</button>
				{showMore && (
					<div className="absolute top-full right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-lg shadow-lg z-50 border border-gray-200 dark:border-gray-700">
						{secondary.map(id => {
							const tab = find(id);
							return (
								<button
									key={id}
									onClick={() => { onTabClick?.(id); setShowMore(false); }}
									className={`w-full flex items-center space-x-3 p-3 text-left text-sm font-medium ${
										activeId === id 
											? 'bg-gray-100 dark:bg-gray-700 text-black dark:text-white' 
											: 'text-black dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
									}`}
								>
									<span>{tab.icon}</span>
									<span>{tab.label}</span>
								</button>
							);
						})}
					</div>
				)}
			</div>
		</div>
	);
}
